module.exports = __webpack_public_path__ + "static/media/ts9tj93.a4cd6908.png";